import { render, staticRenderFns } from "./ZyjdItem.vue?vue&type=template&id=bb9c0f16&scoped=true&"
import script from "./ZyjdItem.vue?vue&type=script&lang=js&"
export * from "./ZyjdItem.vue?vue&type=script&lang=js&"
import style0 from "./ZyjdItem.vue?vue&type=style&index=0&id=bb9c0f16&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9c0f16",
  null
  
)

export default component.exports